import React, { createContext, useState, useCallback } from 'react';

type OpenPosition = 'sidebar' | 'center';

interface FreyaPopoverContextType {
  isOpen: boolean;
  hasSession: boolean;
  openPosition: OpenPosition;
  openPopover: (position?: OpenPosition) => void;
  closePopover: () => void;
  reopenPopover: () => void;
  endSession: () => void;
}

const defaultContext: FreyaPopoverContextType = {
  isOpen: false,
  hasSession: false,
  openPosition: 'sidebar',
  openPopover: () => {},
  closePopover: () => {},
  reopenPopover: () => {},
  endSession: () => {},
};

const FreyaPopoverContext = createContext<FreyaPopoverContextType>(defaultContext);

export const FreyaPopoverProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasSession, setHasSession] = useState(false);
  const [openPosition, setOpenPosition] = useState<OpenPosition>('sidebar');

  const openPopover = useCallback((position: OpenPosition = 'sidebar') => {
    setOpenPosition(position);
    setIsOpen(true);
  }, []);

  const closePopover = useCallback(() => {
    setIsOpen(false);
    setHasSession(true);
  }, []);

  const reopenPopover = useCallback(() => {
    setIsOpen(true);
  }, []);

  const endSession = useCallback(() => {
    setIsOpen(false);
    setHasSession(false);
  }, []);

  return (
    <FreyaPopoverContext.Provider value={{ isOpen, hasSession, openPosition, openPopover, closePopover, reopenPopover, endSession }}>
      {children}
    </FreyaPopoverContext.Provider>
  );
};

export default FreyaPopoverContext;
